// removed by extract-text-webpack-plugin
module.exports = {"matrix":"Ikmh"};


//////////////////
// WEBPACK FOOTER
// ./src/components/matrix/index.less
// module id = 247
// module chunks = 0